import { useEffect, useState } from "react";
import Collapse from "./Collapse";
import { CollapseGroupInterface } from "../../../Interfaces/CollapseInterface";


const CollapseGroup = ({
  items,
  removeElementAfterChange,
  className,
  onChange
}: CollapseGroupInterface) => {
  debugger
  const [activeCollapses, setActiveCollapses] = useState<number[]>(items?.map((x, i) => x.openDefault ? i : -1).filter(x => x !== -1) ?? []);
  const onClick = (index: number) => {
    var listActive = [...activeCollapses];
    if (listActive.includes(index))
      listActive = listActive.filter(x => x !== index);
    else
      listActive.push(index);

    setActiveCollapses(listActive)
  }
  useEffect(() => {
    if (activeCollapses.length !== 0) {
      onChange?.()
    }
  }, [activeCollapses])
  return (
    <>
      <div
        className={`${className ?? ""
          } flex justify-center items-center flex-col gap-[1px]`}
      >
        {items?.map(
          (n, i) =>
            n.isShow && (
              <Collapse
                className={n.className}
                title={n.title}
                icon={n.icon}
                key={i}
                index={activeCollapses.includes(i)}
                keyItem={i}
                classNameOnSelected={n.classNameOnSelected}
                isShow={n.isShow}
                onClick={(index) =>
                  onClick(index)
                }
                element={
                  activeCollapses.includes(i) || !removeElementAfterChange ? (
                    n.element
                  ) : (
                    <></>
                  )
                }
              />
            )
        )}
      </div>
    </>
  );
};

export default CollapseGroup;
